import { configureStore } from "@reduxjs/toolkit";
import { currentUserSlice } from "./slices/misc/currentUser";
import { menuDataSlice } from "./slices/misc/menuData";
import { accessibilitySlice } from "./slices/misc/accessibility";
import { allowedRoutesSlice } from "./slices/misc/allowedRoutes";
import { defaultReportTemplateSlice } from "./slices/misc/defaultReportTemplate";
import highlightReducer from "./slices/misc/highlightSlice";
import notificationReducer from "./slices/misc/notificationSlice";
import { AllProjectsListViewTableColumnsConfigSlice } from "./slices/projectManagement/all-projects/allProjectsListViewTableColumnsConfig";
import { AllProjectsListViewTypeSlice } from "./slices/projectManagement/all-projects/allProjectsListViewType";
import { SideNavCollapseStatusSlice } from "./slices/projectManagement/SideNavCollapseStatus";
import { PendingProjectsListViewTableColumnsConfigSlice } from "./slices/projectManagement/pending-projects/PendingProjectsListViewTableColumnsConfig";
import { CalendarsListViewTableColumnsConfigSlice } from "./slices/projectManagement/calendars/CalendarsListViewTableColumnsConfig";
import { PendingProjectsListViewTypeSlice } from "./slices/projectManagement/pending-projects/PendingProjectsListViewType";
import { CalendarsListViewTypeSlice } from "./slices/projectManagement/calendars/CalendarsListViewType";
import { RootPageRenderSlice } from "./slices/projectManagement/project-view/ProjectInDetail";
import { PhaseInDetailModalSlice } from "./slices/projectManagement/phase-view/PhaseInDetailView";
import { ActivityInDetailModalSlice } from "./slices/projectManagement/activity-view/ActivityInDetailView";
import { TaskListDetailsModalSlice } from "./slices/projectManagement/task-list-view/TaskListDetailModalSlice";
import { IssueInDetailModalSlice } from "./slices/projectManagement/issuee-view/IssueInDetailView";
import { TimeLogInDetailModalSlice } from "./slices/projectManagement/time-log-view/TimeLogDetailView";
import workApprovalsReducer from "./slices/projectManagement/work-approval/workApprovalsSlice";
import UserDetailModalSlice from "./slices/projectManagement/user-detail-view/UserDetailModalSlice";
import { ReportInDetailModalSlice } from "./slices/expenses/ReportInDetailView";
import socketReducer from "./slices/misc/socketSlice";
import pendingJobsReducer from "./slices/misc/pendingJobsSlice";
import layoutReducer from "./slices/layout/layoutSlice";

export const store = configureStore({
  reducer: {
    // key : slice.reducer
    currentUser: currentUserSlice.reducer,
    menu: menuDataSlice.reducer,
    accessibility: accessibilitySlice.reducer,
    allowedRoutes: allowedRoutesSlice.reducer,
    defaultReportTemplate: defaultReportTemplateSlice.reducer,
    highlight: highlightReducer,
    notification: notificationReducer,
    AllProjectsListViewTableColumnsConfig:
      AllProjectsListViewTableColumnsConfigSlice.reducer,
    PendingProjectsListViewTableColumnsConfig:
      PendingProjectsListViewTableColumnsConfigSlice.reducer,
    CalendarsListViewTableColumnsConfig:
      CalendarsListViewTableColumnsConfigSlice.reducer,

    AllProjectsListViewType: AllProjectsListViewTypeSlice.reducer,
    PendingProjectsListViewType: PendingProjectsListViewTypeSlice.reducer,
    CalendarsListViewType: CalendarsListViewTypeSlice.reducer,

    SideNavCollapseStatus: SideNavCollapseStatusSlice.reducer,
    RootPageRenderState: RootPageRenderSlice.reducer,
    // ProjectInDetailModal: ProjectInDetailModalSlice.reducer,
    PhaseInDetailModal: PhaseInDetailModalSlice.reducer,
    ActivityInDetailModal: ActivityInDetailModalSlice.reducer,
    TaskListInDetailModal: TaskListDetailsModalSlice.reducer,
    IssueListInDetailModal: IssueInDetailModalSlice.reducer,
    TimeLogListDetailModal: TimeLogInDetailModalSlice.reducer,
    workApprovals: workApprovalsReducer,
    UserDetailModalSlice: UserDetailModalSlice.reducer,
    ReportInDetailModal: ReportInDetailModalSlice.reducer,
    socket: socketReducer,
    pendingJobs: pendingJobsReducer,
    layout: layoutReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
